<template>
  <el-dropdown
    ref="mobileDD"
    :class="additionalClasses"
    @command="(event) => $emit('command', event)"
  >
    <span class="el-dropdown-link">
      <div class="d-flex align-items-center justify-content-end pt-2">
        <user-avatar
          class="mx-2 mx-lg-0"
          :user="$store.state.user?.user ?? 'J'"
          size="sm"
        />
        <button class="btn btn-account d-none d-lg-block">
          <i class="icon-chevron-down text-primary"></i>
        </button>
      </div>
    </span>
    <template #dropdown>
      <el-dropdown-menu class="wrapper-dropdown container no-left">
        <div class="pt-4 px-4">
          <h2 class="mb-0">Olá, {{ user && user.name }}</h2>
        </div>

        <div>
          <hr class="mt-4" />
        </div>

        <el-dropdown-item class="d-grid gap-2">
          <router-link
            :to="{ name: 'my-profile' }"
            class="btn ps-0 d-flex justify-content-start"
            @click="$emit('click-menu')"
          >
            Meu perfil
          </router-link>
        </el-dropdown-item>

        <el-dropdown-item class="d-grid gap-2">
          <router-link
            :to="{ name: 'account' }"
            class="btn ps-0 d-flex justify-content-start"
            @click="$emit('click-menu')"
          >
            Conta
          </router-link>
        </el-dropdown-item>

        <el-dropdown-item class="d-grid gap-2">
          <router-link
            :to="{ name: 'signature' }"
            class="btn ps-0 d-flex justify-content-start"
            @click="$emit('click-menu')"
          >
            Assinatura
          </router-link>
        </el-dropdown-item>

        <el-dropdown-item class="d-grid gap-2">
          <button
            class="btn d-block ps-0 d-flex justify-content-start"
            style="font-weight: 400"
            @click="$emit('logout')"
          >
            Sair
          </button>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
<script>
import UserAvatar from "@/components/UserAvatar.vue";
import { mapState } from "vuex";
export default {
  props: ["additionalClasses"],
  components: { UserAvatar },
  computed: {
    ...mapState("user", ["user"]),
  },
};
</script>
